class CodeValueSilder extends HTMLElement {
    constructor() {
      super();
  
      this.isMouseenter = false;
      this.elements = {
        slider_element: this.querySelector('.main_swiper'),
        silderThub: this.querySelector('[thumbsSlider]')
      }
      this.init();
    }
  
    connectedCallback() {
      if (Shopify.designMode) {
        this.onShopifySectionLoad = this.onSectionLoad.bind(this);
        this.onShopifySectionSelect = this.onSectionSelect.bind(this);
        this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
        document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
        document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
        document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
      }
    }
  
    disconnectedCallback() {
      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
        document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
        document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
      }
    }
  
    onSectionLoad(event) {
      filterShopifyEvent(event, this, this.initSlider.bind(this));
    }
    onSectionSelect(event) {
      filterShopifyEvent(event, this, this.initSlider.bind(this));
    }
    onSectionDeselect(event) {
      filterShopifyEvent(event, this, this.initSlider.bind(this));
    }
  
    init() {
      if (Shopify && Shopify.designMode) this.initSlider();
      setTimeout(() => this.initSlider());
    }
    
  
    initSlider() {
        var swiper = new Swiper(this.elements.silderThub, {
            spaceBetween: 2,
            slidesPerView: 6,
            freeMode: true,
            watchSlidesProgress: true,
        });
      var swiper2 = new Swiper(this.elements.slider_element, {
        spaceBetween: 10,
        slidesPerView: 1,
        paginationClickable: true,
        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        },
        thumbs: {
            swiper: swiper,
        },
        on: {
            init: (element) => {
          
            }
          }
      });
    }
  }
  
  customElements.define('code-value-silder', CodeValueSilder);